import { render, staticRenderFns } from "./XtendTable.vue?vue&type=template&id=001e1fc7&"
import script from "./XtendTable.vue?vue&type=script&lang=js&"
export * from "./XtendTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports